import { __decorate } from "tslib";
import { FormInputText } from '../text/element';
import { Email } from '../../../../../lib/validate/email';
import { property } from 'lit/decorators.js';
export class FormInputEmail extends FormInputText {
    constructor() {
        super(...arguments);
        this.type = 'email';
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        setTimeout(() => {
            this.validator = new Email(this);
        }, 100);
    }
}
__decorate([
    property()
], FormInputEmail.prototype, "emailErrorMsg", void 0);
if (!customElements.get('ep-form-input-email')) {
    customElements.define('ep-form-input-email', FormInputEmail);
}
//# sourceMappingURL=element.js.map